import React from 'react';
import './Features.css';
import { SpeedIcon, ShieldIcon, TrendingIcon } from './Icons';

const Features = () => {
  const features = [
    {
      icon: <SpeedIcon size={48} color="#00d4ff" />,
      title: 'Instant Transfer',
      description: 'Get your Flash USDT instantly with our lightning-fast processing system. No delays, no waiting.'
    },
    {
      icon: <ShieldIcon size={48} color="#00d4ff" />,
      title: 'Bank-Grade Security',
      description: 'Your assets are protected with military-grade encryption and advanced security protocols.'
    },
    {
      icon: <TrendingIcon size={48} color="#00d4ff" />,
      title: 'Best Rates',
      description: 'Competitive pricing with transparent fees. Get the best value for your money, guaranteed.'
    }
  ];

  return (
    <section className="features" id="features">
      <div className="container">
        <h2>Why Choose <span className="highlight">ShopUSDT.in</span></h2>
        <p className="section-subtitle">Your trusted partner for Flash USDT transactions</p>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
